import 'appboy-web-sdk/appboy.min.css';

import 'core-js/fn/object/assign';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import Parse from 'parse';
import _ from 'lodash';
import { BrowserRouter } from 'react-router-dom'
import App from '../shared/app';
import createStore from '../shared/stores/createStore'
import { Provider } from 'react-redux'
import config from 'sharedConfig';
import {loggedIn, anonymousUser} from 'components/login/actions';
import {loadVariant} from 'components/app/actions';
import {track} from 'shared/models/analytic';
import {startNewSession, isNewSession} from 'shared/utils/sessionStore';
import ScrollPreserver from 'shared/components/ui/scrollPreserver';


window.stripe = Stripe(config.stripe.pk);
Parse.initialize(config.parse.appId, config.parse.key);
Parse.serverURL = config.parse.serverURL;

// facebook
window.fbAsyncInit = function() {
  Parse.FacebookUtils.init({
    appId      : config.facebook.appId,
    xfbml      : true,
    version    : 'v2.9'
  });
};
(function(d, s, id){
 var js, fjs = d.getElementsByTagName(s)[0];
 if (d.getElementById(id)) {return;}
 js = d.createElement(s); js.id = id;
 js.src = '//connect.facebook.net/en_US/sdk.js';
 fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

// branch
(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode banner closeBanner creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setIdentity track validateCode".split(" "), 0);
branch.init(config.branch.key);

if (window.analytics) {
  window.analytics.ready(() => {
    window.appboy.subscribeToNewInAppMessages(inAppMessages => {
      if (inAppMessages && inAppMessages[0] instanceof appboy.ab.InAppMessage) {
        track('Saucey Custom Alert Viewed');
        const extras = inAppMessages[0].extras;
        if (extras.icon) {
          document.body.classList.add('ab-modal--icon')
        } else {
          document.body.classList.remove('ab-modal--icon')
        }
      }
    });
  });
}

const store = createStore(window.__PRELOADED_STATE__)

window.loadVariant = function(experimentName, variantName) {
  store.dispatch(loadVariant(experimentName, variantName));
}

ReactDOM.hydrate(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollPreserver>
        <App />
      </ScrollPreserver>
    </BrowserRouter>
  </Provider>,
  document.getElementById('app')
);

if (__PRELOADED_STATE__.login && __PRELOADED_STATE__.login.user) {
  loggedIn(__PRELOADED_STATE__.login.user);
} else {
  anonymousUser();
}

if (__PRELOADED_STATE__.address && !_.isEmpty(__PRELOADED_STATE__.address.address) && isNewSession()) {
  track('Delivery Address Set', { source: 'cache' })
}

startNewSession();



// WEBPACK FOOTER //
// ./client/index.js